import DiamondIcon from "@mui/icons-material/Diamond";
import { useTranslation } from "react-i18next";

import RouterLink from "../router-link";
import { Paths } from "../../features/subscriptions";

const SubscribeButton = ({ onClick }: { onClick?: () => void }) => {
  const { t } = useTranslation("coi-platform-translations");

  return (
    <RouterLink.Button
      to={Paths.Root}
      variant="contained"
      data-testid="start-subscription"
      sx={{
        backgroundColor: "gold.main",
        color: "brown.main",
        ":hover": {
          backgroundColor: "gold.dark",
        },
      }}
      onClick={onClick}
    >
      <DiamondIcon sx={{ marginRight: "8px", fontSize: "18px" }} />
      {t("navigation.subscription_button")}
    </RouterLink.Button>
  );
};

export { SubscribeButton };
